import {
	Action,
	Module,
	Mutation,
	VuexModule,
} from 'vuex-module-decorators';
import { HelpCenterFAQContent } from '@/help-center/types/help-center-faq-content';
import { HelpCenterFIContactInfo } from '@/help-center/types/help-center-fi-contact-info';
import { HelpCenterVersionsContent } from '@/help-center/types/help-center-version-content';
import { HelpCenterFAQEntry } from '@/help-center/types/help-center-faq-entry';
import { HelpCenterVersionsEntry } from '@/help-center/types/help-center-version-entry';
import { HelpCenterFAQEntryFields } from '@/help-center/types/help-center-faq-entry-fields';
import { ContentfulHelper } from '@/contentful/helper';

@Module({
	namespaced: true,
	name: 'helpCenter',
})
export default class HelpCenterStore extends VuexModule {
	public FAQContent: HelpCenterFAQContent | null = null;

	public fiContactInfo!: HelpCenterFIContactInfo;

	public versionsContent: HelpCenterVersionsContent | null = null;

	get FAQEntries(): HelpCenterFAQEntry[] {
		return this.FAQContent?.includes.Entry || [];
	}

	get FAQtopics(): HelpCenterFAQEntry[] {
		const { FAQEntries } = this;
		return FAQEntries.filter((i: HelpCenterFAQEntry) => i.sys.contentType.sys.id === 'topic') || [];
	}

	get FAQquestions(): HelpCenterFAQEntry[] {
		const { FAQEntries } = this;
		return FAQEntries.filter((i: HelpCenterFAQEntry) => i.sys.contentType.sys.id === 'faq') || [];
	}

	get isFAQContentSet(): boolean {
		return !!this.FAQContent;
	}

	get isVersionsContentSet(): boolean {
		return !!this.versionsContent;
	}

	get versionsEntries(): HelpCenterVersionsEntry[] {
		return this.versionsContent?.items || [];
	}

	@Mutation
	public setFAQContent(content: HelpCenterFAQContent): void {
		this.FAQContent = content;
	}

	@Mutation
	public setFiContactInfo(info: HelpCenterFIContactInfo): void {
		this.fiContactInfo = info;
	}

	@Mutation
	public setVersionsContent(content: HelpCenterVersionsContent): void {
		this.versionsContent = content;
	}

	@Action({ rawError: true })
	public async getFAQTopicQuestions(topic: HelpCenterFAQEntry): Promise<HelpCenterFAQEntry[]> {
		const topicFieldQuestions = topic.fields.questions || [];
		const questions = this.FAQquestions.filter((q) => topicFieldQuestions.find((t) => t.sys.id === q.sys.id));

		return questions;
	}

	@Action({ rawError: true })
	public async orderFAQTopics(topicIds: string[]): Promise<void> {
		const { FAQtopics } = this;
		const unshiftedTopics = ContentfulHelper.unshiftEntries<HelpCenterFAQEntryFields>(FAQtopics, topicIds);

		await this.setFAQTopics(unshiftedTopics);
	}

	@Action({ rawError: true })
	public async setFAQTopics(topics: HelpCenterFAQEntry[]): Promise<void> {
		const { FAQquestions } = this;

		if (this.FAQContent) {
			this.FAQContent.includes.Entry = [...FAQquestions, ...topics];
		}
	}
}
